<template>
  <div class="brand">
    <List :list="brandData" :titleHref="'/brand'" />
    <Pagination @pageNumber="pageBtn" :pageSize="pageSize" :count="count"></Pagination>
  </div>
</template>
<script>
import List from '@/components/list';
import { brandJson } from '@/json/list';
import Pagination from '../components/pagination';

export default {
  name:'brand',
  data() {
    return {
      count: brandJson.length,
      brandData: brandJson,
      pageSize: 12,
    }
  },
  methods:{
    pageBtn(i,maxLength){
      this.brandData = [];
      brandJson.map((item,index) => {
        if(index < maxLength && index >= i)
          this.brandData.push(item)
      })
    }
  },
  components:{
    List,
    Pagination,
  },
}
</script>
<style lang="scss" scoped>
  .brand{
    width:$navWidth;
    margin:20px auto 40px;
    border-radius: 5px;
  }
</style>
